export default "/images/candy-image-80.png?e34f93f4602e2c0860caf5ebd710c979";